export function isAdminOrCollaborator() {
	return ['admin', 'collaborator'].includes(this.user.user_group)
}
